// ノートテンプレートの編集可否とグループ選択肢まわり
// 仕様: docs/superpowers/specs/2026-09-14-note-template-department-options-design.html
//
// 編集可否は API が operator ごとに算出して editableStatus で返す（api#387）。
// ロール（メンバー・保護者は常に編集不可）も API 側の条件に含まれるため、
// フロントで同じ判定を持たず、この値だけを見る。

// api#387 の EditableStatus と対応する。値の文字列は API と揃えること
export const EDITABLE_STATUS = {
  EDITABLE: 'editable',
  DEPARTMENTS_LOCKED: 'departments_locked',
  NOT_EDITABLE: 'not_editable'
}

// 編集不能になったテンプレートを更新・削除しようとしたときの案内。
// 開いている間に別のユーザーがグループを付け替えると起きる
export const TEMPLATE_CHANGED_MESSAGE = 'このテンプレートは編集できなくなりました。他のユーザーがグループを変更した可能性があります。'

// 編集・削除を許す editableStatus。ここに無い値はすべて編集不可として扱う
const EDITABLE_VALUES = [EDITABLE_STATUS.EDITABLE, EDITABLE_STATUS.DEPARTMENTS_LOCKED]

// 更新・削除できるテンプレートか。
// 未返却・null・未知の値は編集不可に倒す。editableStatus を返さない古い API へ
// 切り戻されたとき、その API には 404 の防御も無いため、UI で通すと本当に更新できてしまう
export const canEditNoteTemplate = (noteTemplate) => {
  if (!noteTemplate) return false
  return EDITABLE_VALUES.includes(noteTemplate.editableStatus)
}

// 編集画面でグループ欄をロックするか。
// 閲覧権限のないグループが混ざっていると、選択肢に出せないグループを
// フォームから復元できずに取りこぼすため、付け替え自体をさせない
export const isDepartmentLocked = (noteTemplate) => {
  if (!noteTemplate) return false
  return noteTemplate.editableStatus === EDITABLE_STATUS.DEPARTMENTS_LOCKED
}

// ロック時のチェックボックスに並べる選択肢。
// 何が設定されているか読めるよう、権限外グループも末尾に足して表示する。
// この組み立ては API から取れないのでフロントに残す
export const buildLockedDepartmentOptions = (accessibleDepartments, noteTemplate) => {
  const options = [...accessibleDepartments || []]
  const seenIds = options.map(department => department.id)
  const departments = noteTemplate && noteTemplate.departments || []
  departments.forEach(department => {
    if (seenIds.includes(department.id)) return
    options.push(department)
    seenIds.push(department.id)
  })
  return options
}
